var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.clickCurrent == _vm.index,
            expression: "clickCurrent==index"
          }
        ],
        class:
          _vm.temp.type == 1 &&
          _vm.temp.getViewLogCount &&
          _vm.temp.getViewLogCount != 1
            ? "view-log-min-footer"
            : "view-log-info-footer"
      },
      [
        _vm.temp.type == 1
          ? _c("div", [
              _vm.showStatus(_vm.temp) == "success"
                ? _c("div", { staticClass: "log-line" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.result")) +
                        ": " +
                        _vm._s(_vm.$t("language.common.success"))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showStatus(_vm.temp) == "failure"
                ? _c("div", { staticClass: "log-line" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.result")) +
                        ":" +
                        _vm._s(_vm.$t("language.common.failure"))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showStatus(_vm.temp) == "patial"
                ? _c("div", { staticClass: "log-line" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.result")) +
                        ":" +
                        _vm._s(_vm.$t("language.common.patial"))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showStatus(_vm.temp) == "cancel"
                ? _c("div", { staticClass: "log-line" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.result")) +
                        ":" +
                        _vm._s(_vm.$t("language.common.canceled"))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.temp.lastLog
                ? _c("div", [
                    _vm.temp.branchType != "businessTransfer"
                      ? _c("div", { staticClass: "log-line" }, [
                          _c("div", { staticClass: "log-single-left" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.fileProcess")) +
                                ":" +
                                _vm._s(_vm.temp.lastLog.readyTranFileCount) +
                                "/" +
                                _vm._s(_vm.temp.lastLog.totalFileCount)
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "log-single-right" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.dataProcess")) +
                                ": " +
                                _vm._s(
                                  _vm._f("formatByte")(
                                    _vm.temp.lastLog.fileTotalReadedBytes
                                  )
                                ) +
                                "/" +
                                _vm._s(
                                  _vm._f("formatByte")(
                                    _vm.temp.lastLog.totalBytes
                                  )
                                )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.temp.branchType == "businessTransfer"
                      ? _c("div", { staticClass: "log-line" }, [
                          _c(
                            "div",
                            {
                              staticClass: "log-single-left",
                              staticStyle: { width: "100%" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.fileProcess")) +
                                  ":" +
                                  _vm._s(_vm.temp.lastLog.readyTranFileCount) +
                                  "/" +
                                  _vm._s(_vm.temp.lastLog.totalFileCount)
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.temp.branchType == "businessTransfer"
                      ? _c("div", { staticClass: "log-line" }, [
                          _c(
                            "div",
                            {
                              staticClass: "log-single-left",
                              staticStyle: { width: "100%" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.dataProcess")) +
                                  ":" +
                                  _vm._s(
                                    _vm._f("formatByte")(
                                      _vm.temp.lastLog.fileTotalReadedBytes
                                    )
                                  ) +
                                  "/" +
                                  _vm._s(
                                    _vm._f("formatByte")(
                                      _vm.temp.lastLog.totalBytes
                                    )
                                  )
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "log-line" }, [
                      _c("div", { staticClass: "log-single-left" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.common.startTime")) +
                            ":" +
                            _vm._s(_vm.temp.lastLog.taskStartTimeStr)
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "log-single-right" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.common.endTime")) +
                            ":" +
                            _vm._s(_vm._f("getEndTime")(_vm.temp.lastLog))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "log-line" }, [
                      _c("div", { staticClass: "log-single-left" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.common.averageRateSpecial")) +
                            ": " +
                            _vm._s(
                              _vm._f("formatByteSpeed")(
                                _vm.temp.lastLog.fileTotalReadedBytes /
                                  (_vm.temp.lastLog.taskElaspedTimeLong / 1000)
                              )
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "log-single-right" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.common.executedTimes")) +
                            ":" +
                            _vm._s(_vm.temp.runCount)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.temp.lastLog &&
                    _vm.temp.lastLog.totalBytes &&
                    _vm.temp.lastLog.fileTotalReadedBytes ==
                      _vm.temp.lastLog.totalBytes &&
                    _vm.temp.lastLog &&
                    !_vm.temp.lastLog.errorList.length
                      ? _c("div", { staticClass: "log-line" }, [
                          _vm._v(
                            "\r\n                " +
                              _vm._s(_vm.$t("language.common.fileSuccess")) +
                              "\r\n            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.temp.lastLog && _vm.temp.lastLog.errorList.length
                      ? _c("div", { staticClass: "log-line" }, [
                          _c(
                            "div",
                            {
                              staticClass: "log-failed-left click-log-red",
                              on: {
                                click: function($event) {
                                  return _vm.openFailedFiles()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\r\n                    " +
                                  _vm._s(_vm.$t("language.common.viewFailed")) +
                                  "\r\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.temp.retryed
                            ? _c(
                                "div",
                                {
                                  staticClass: "log-retry-right click-log-blue",
                                  on: {
                                    click: function($event) {
                                      return _vm.retryAll(_vm.temp)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\r\n                    " +
                                      _vm._s(
                                        _vm.$t("language.common.retryAll")
                                      ) +
                                      "\r\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.temp.retryed
                            ? _c(
                                "div",
                                {
                                  staticClass: "log-retry-right click-log-blue",
                                  on: {
                                    click: function($event) {
                                      return _vm.toAimRootCatalog(_vm.temp)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("language.common.viewProgress")
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.temp.lastLog &&
                    _vm.temp.lastLog.response ==
                      "Not enough data traffic for cloud to cloud transmission"
                      ? _c(
                          "div",
                          {
                            staticClass: "log-failed-left ",
                            staticStyle: { color: "red" }
                          },
                          [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.$t("language.taskList.notTraffic")) +
                                "\r\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.temp.lastLog &&
              _vm.temp.getViewLogCount == 1 &&
              _vm.temp.branchType != "businessTransfer"
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        float: "left",
                        "margin-top": "5Px",
                        color: "#4281FF"
                      }
                    },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("language.common.loadData"))),
                        _c("span", { staticClass: "loadViewLogs" })
                      ])
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.temp.type == 2
          ? _c("div", [
              _vm.showStatus(_vm.temp) == "success"
                ? _c("div", { staticClass: "log-line" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.result")) +
                        ": " +
                        _vm._s(_vm.$t("language.common.success"))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showStatus(_vm.temp) == "failure"
                ? _c("div", { staticClass: "log-line" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.result")) +
                        ":" +
                        _vm._s(_vm.$t("language.common.failure"))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showStatus(_vm.temp) == "patial"
                ? _c("div", { staticClass: "log-line" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.result")) +
                        ":" +
                        _vm._s(_vm.$t("language.common.patial"))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showStatus(_vm.temp) == "cancel"
                ? _c("div", { staticClass: "log-line" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.result")) +
                        ":" +
                        _vm._s(_vm.$t("language.common.canceled"))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.temp.lastLog
                ? _c("div", [
                    _vm.temp.lastLog
                      ? _c("div", { staticClass: "log-line" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.fileProcess")) +
                                ":Add[" +
                                _vm._s(_vm.temp.lastLog.addFile) +
                                "] Update[" +
                                _vm._s(_vm.temp.lastLog.updateFile) +
                                "] Delete[" +
                                _vm._s(_vm.temp.lastLog.deleteFile) +
                                "]"
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.temp.lastLog
                      ? _c("div", { staticClass: "log-line" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.dataProcess")) +
                                ": " +
                                _vm._s(
                                  _vm._f("formatByte")(
                                    _vm.temp.lastLog.fileTotalReadedBytes
                                  )
                                ) +
                                "/" +
                                _vm._s(
                                  _vm._f("formatByte")(
                                    _vm.temp.lastLog.totalBytes
                                  )
                                )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.temp.lastLog
                      ? _c("div", { staticClass: "log-line" }, [
                          _c("div", { staticClass: "log-single-left" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.startTime")) +
                                ":" +
                                _vm._s(_vm.temp.lastLog.taskStartTimeStr)
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "log-single-right" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.endTime")) +
                                ":" +
                                _vm._s(_vm._f("getEndTime")(_vm.temp.lastLog))
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "log-line" }, [
                      _vm.temp.lastLog
                        ? _c("div", { staticClass: "log-single-left" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.common.averageRateSpecial")
                              ) +
                                ": " +
                                _vm._s(
                                  _vm._f("formatByteSpeed")(
                                    _vm.temp.lastLog.fileTotalReadedBytes /
                                      (_vm.temp.lastLog.taskElaspedTimeLong /
                                        1000)
                                  )
                                )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "log-single-right" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.common.executedTimes")) +
                            ":" +
                            _vm._s(_vm.temp.runCount)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.temp.lastLog &&
                    _vm.temp.lastLog.totalBytes &&
                    _vm.temp.lastLog.fileTotalReadedBytes ==
                      _vm.temp.lastLog.totalBytes
                      ? _c("div", { staticClass: "log-line" }, [
                          _vm._v(
                            "\r\n                " +
                              _vm._s(_vm.$t("language.common.fileSuccess")) +
                              "\r\n            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.temp.lastLog && _vm.temp.lastLog.errorList.length
                      ? _c("div", { staticClass: "log-line" }, [
                          _c(
                            "div",
                            {
                              staticClass: "log-failed-left click-log-red",
                              on: {
                                click: function($event) {
                                  return _vm.openFailedFiles()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\r\n                    " +
                                  _vm._s(_vm.$t("language.common.viewFailed")) +
                                  "\r\n                "
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.temp.lastLog &&
                    _vm.temp.lastLog.response ==
                      "Not enough data traffic for cloud to cloud transmission"
                      ? _c(
                          "div",
                          {
                            staticClass: "log-failed-left ",
                            staticStyle: { color: "red" }
                          },
                          [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.$t("language.taskList.notTraffic")) +
                                "\r\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _c(
                    "div",
                    {
                      staticStyle: {
                        float: "left",
                        "margin-top": "5Px",
                        color: "#4281FF"
                      }
                    },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("language.common.loadData"))),
                        _c("span", { staticClass: "loadViewLogs" })
                      ])
                    ]
                  )
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-456d2320", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-456d2320","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_detailed_progress/tab_logs_detail.vue
// module id = null
// module chunks = 